/// <amd-module name="Wit/WorkItemForm/Attachments/AttachmentsViewToggle" />
import * as React from "react";
import { useEffect } from "react";
import { Button } from "VSSUI/Button";
import { IconSize } from "VSSUI/Icon";
import * as Resources from "Wit/WorkItemForm/Resources";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";
import { useService } from "VSS/Platform/Layout";

const attachmentsViewTypeSetting = "WorkItemForm/AttachmentsViewType";

export interface IAttachmentsViewToggleProps {
    className: string;
    viewType: "grid" | "thumbnail";
    onViewTypeChanged: (viewType: "grid" | "thumbnail") => void;
}

export function AttachmentsViewToggle({ className, viewType, onViewTypeChanged }: IAttachmentsViewToggleProps) {
    const settingsService = useService<ISettingsService>("ISettingsService");

    useEffect(() => {
        const initialCollapsedState = settingsService.getEntry<{ [key: string]: string }>(attachmentsViewTypeSetting, SettingsUserScope.Me)?.ViewType;
        if (initialCollapsedState === "grid" || initialCollapsedState === "thumbnail") {
            onViewTypeChanged(initialCollapsedState);
        }
    }, []);

    const onViewTypeChangeClick = (value: "grid" | "thumbnail") => {
        const entries = { [`${attachmentsViewTypeSetting}/ViewType`]: value };
        settingsService.setEntries(entries, SettingsUserScope.Me);
        onViewTypeChanged(value);
    };

    return (
        <span className={`attachments-view-toggle ${className}`}>
            <Button
                subtle
                className={viewType === "grid" ? "toggle-button-active" : ""}
                iconProps={{ iconName: "BulletedListText", size: IconSize.large }}
                onClick={() => onViewTypeChangeClick("grid")}
                disabled={viewType === "grid"}
                tooltipProps={{ text: Resources.AttachmentsGridView }}
            />
            <Button
                subtle
                className={viewType === "thumbnail" ? "toggle-button-active" : ""}
                iconProps={{ iconName: "GridViewSmall", size: IconSize.large }}
                onClick={() => onViewTypeChangeClick("thumbnail")}
                disabled={viewType === "thumbnail"}
                tooltipProps={{ text: Resources.AttachmentsThumbnailView }}
            />
        </span>
    );
}
